function nomedomes(pIdx){

    var meses = ["Janeiro", "Fevereiro", "Março", "Abril",
    "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro",
    "Novembro", "Dezembro"];

    return meses[pIdx];

}


function diasemana(pIdx){

    var dias = ["Domingo", "Segunda-Feira", "Terça-Feira", "Quarta-Feira",
    "Quinta-Feira", "Sexta-Feira", "Sábado"];

    return dias[pIdx];

}

export {nomedomes, diasemana};